'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _desc, _value, _class3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _index = require('base-viewstore/index.js');

var _index2 = _interopRequireDefault(_index);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _simboxEditable = require('simbox-editable');

var _editor = require('simbox-editable/editor');

var _editor2 = _interopRequireDefault(_editor);

var _collectionGridEditor = require('collection-grid-editor');

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _layoutComponent = require('layout-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SystemEditor = (_dec = (0, _mobxReact.inject)("modalViewStore"), _dec(_class = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_BaseComponent) {
  (0, _inherits3.default)(SystemEditor, _BaseComponent);

  function SystemEditor() {
    (0, _classCallCheck3.default)(this, SystemEditor);
    return (0, _possibleConstructorReturn3.default)(this, (SystemEditor.__proto__ || (0, _getPrototypeOf2.default)(SystemEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(SystemEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          currentView = _props.currentView,
          contentModel = _props.contentModel;
      var publishEntities = this.viewStore.publishEntities;


      if (!options.insideEditor) return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_collectionGridEditor2.default, { currentView: currentView, contentModel: contentModel }),
        _react2.default.createElement(
          'div',
          { className: 'editable-group' },
          _react2.default.createElement(
            'button',
            { className: 'btn red', onClick: publishEntities },
            'PUBLISH ALL ENTITIES'
          )
        )
      );

      return _react2.default.createElement(_editor2.default, this.props);
    }
  }]);
  return SystemEditor;
}(_baseComponent2.default), _class2.ViewStore = (_dec2 = _mobx.action.bound, (_class3 = function (_BaseViewStore) {
  (0, _inherits3.default)(SystemViewStore, _BaseViewStore);

  function SystemViewStore() {
    (0, _classCallCheck3.default)(this, SystemViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (SystemViewStore.__proto__ || (0, _getPrototypeOf2.default)(SystemViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(SystemViewStore, [{
    key: 'publishEntities',
    value: function publishEntities(e) {
      var modalViewStore = this.props.modalViewStore;

      var system = this.props.contentModel;
      var Configuration = system.$parent.entities.get("Configuration");
      modalViewStore.setModal({
        title: "Publish Entities?",
        message: /*Configuration.anyDirty ?  "You have unsaved changes.  Unable to publish.": */"Would you like to publish all entities to entities.json?",
        confirmLabel: 'Continue',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: /*!Configuration.anyDirty && */function onConfirmFunc() {
          return system.publishEntities({
            cm: Configuration,
            path: "entities",
            cb: function cb() {
              modalViewStore.setModal({
                title: "Published",
                message: "You have published your entities to entitites.json.  Please rebuild, and release to stage.",
                confirmLabel: 'Continue',
                confirmBtnClass: 'green check-a'
              });
            }
          });
        }
      });
    }
  }]);
  return SystemViewStore;
}(_index2.default), (_applyDecoratedDescriptor(_class3.prototype, 'publishEntities', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'publishEntities'), _class3.prototype)), _class3)), _temp)) || _class) || _class) || _class);
exports.default = SystemEditor;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SystemEditor, 'SystemEditor', 'src/entity_modules/system-entity/editor.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/system-entity/editor.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/editor.js
// module chunks = 0